
import { auth } from '../auth.js'

const isLoggedIn = async ()=>{
    let authenticated = true;
    try {
        await auth().check()    
    } catch (error) {
        authenticated = false;
    }
    return authenticated    
}

const beforeEach = async (to)=>{
    const isLogged = await isLoggedIn()
    if( isLogged && ( !to.meta.requiresAuth ) ){
        return '/statics'
    }
    if( !isLogged && ( to.meta.requiresAuth ) ){
        return '/'
    }
}

export { beforeEach }